import { takeLatest, put, call, select } from 'redux-saga/effects';
import _get from 'lodash/get';
import getBopisToolTip from 'yoda-interfaces/lib/IrisBopisToolTip/IrisBopisToolTipApi';
import { selectFeatureFlags, selectMessagesTexts } from '../selectors/ContextSelector';
import {
    BOPIS_TOOLTIP_GET_SUCCESS,
    BOPIS_TOOLTIP_GET_REQUEST,
} from '../actionTypes/BOPISToolTipActionType';

function* bopisToolTipSaga() {
    try {
        const { disableIrisBopisTooltipMessage } = yield select(selectFeatureFlags);
        const { bopisTooltip } = yield select(selectMessagesTexts);
        const response = !disableIrisBopisTooltipMessage ? yield call(getBopisToolTip) : '';
        const bopisTooltipMessage = _get(
            response,
            'data.content.components[0].content.html',
            bopisTooltip
        );
        yield put({ type: BOPIS_TOOLTIP_GET_SUCCESS, bopisTooltipMessage });
    } catch (error) {
        console.log('Bopis saga error ', error);
    }
}

const watchBOPISTooltipRequest = function* watchBOPISTooltipRequest() {
    yield takeLatest(BOPIS_TOOLTIP_GET_REQUEST, bopisToolTipSaga);
};

watchBOPISTooltipRequest.sagaName = 'watchBOPISTooltipRequest';

export default watchBOPISTooltipRequest;
